/**
 * Mockup v3 P8 (Galería y enlaces): the strings of the gallery sort and tabs, the version badge,
 * the visitor preview, the label rename and "1 año". Spread into `es` by `es.ts`; P8 adds
 * its keys here only. Copy from the P8 plan's Global Constraints and `mockup-ux-redesign-v3.html`
 * (`SORT_L`, `openVisitor`, the label row and the expiry dialog).
 */
export const esGalleryLinks = {
  "gallery.sort.label": "Ordenar por",
  "gallery.sort.recent": "Más recientes",
  "gallery.sort.updated": "Actualizados",
  "gallery.sort.name": "Nombre A-Z",
  "gallery.sort.button": "Ordenar: {name}",
  "gallery.tabs.all": "Todos",
  "gallery.tabs.favorites": "Favoritos",
  "gallery.tabs.trash": "Papelera",
  "gallery.versionBadge": "v{n}",
  "gallery.versionBadge.label": "Versión {n}",
  "gallery.col.version": "Versiones",
  "sharing.visitor.open": "Ver como visitante",
  "sharing.visitor.title": "Vista de visitante",
  "sharing.visitor.notice": "Así ve «{label}» quien abre el enlace. Esta visita no se cuenta.",
  "sharing.visitor.close": "Cerrar la vista de visitante",
  "sharing.visitor.unsaved": "Enlace sin crear",
  "sharing.visitor.row": "Ver «{label}» como visitante",
  "sharing.label.rename": "Renombrar la etiqueta «{label}»",
  "sharing.label.save": "Guardar",
  "sharing.label.cancel": "Cancelar",
  "sharing.expiry.never": "1 año",
  "sharing.expiry.neverHelp": "«1 año»: el enlace funciona durante un año; después, deja de funcionar.",
  "sharing.expiry.choice": "Caducidad",
  "sharing.expiry.days": "{n} días",
  "sharing.expiry.keep": "Sin cambios",
  "sharing.edit.expiryChoice": "Nueva caducidad",
  "sharing.label.input": "Etiqueta del enlace",
  "sharing.label.failed": "No se pudo renombrar la etiqueta.",
} as const;
